import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from '@emotion/styled';
export var StyledList = styled.ul(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tlist-style: none;\n\tmargin: 0px;\n\tpadding: 0px;\n"])));